import type { AIChatOutputAsset } from '../api'

export type AssetRole = 'generated' | 'inline' | 'reference' | 'decorative' | 'provider_ui' | 'unknown'

export type RichBlockType =
  | 'paragraph'
  | 'heading'
  | 'list'
  | 'list_item'
  | 'table'
  | 'quote'
  | 'code'
  | 'link'
  | 'image'
  | 'image_group'
  | 'card'
  | 'card_group'
  | 'divider'
  | 'unknown'

export interface RichMediaRef {
  ordinal: number
  asset_role?: AssetRole
  alt?: string
}

export interface RichLink {
  href: string
  label?: string
}

export interface RichCard {
  title?: string
  subtitle?: string
  body?: string
  metadata?: Array<{ label?: string; value: string }>
  media_refs?: RichMediaRef[]
  links?: RichLink[]
}

export interface RichResponseV1 {
  version: number
  blocks: RichBlock[]
  meta?: {
    provider?: string
    block_count?: number
    fallback_used?: boolean
    source?: string
  }
}

export interface RichBlock {
  type: RichBlockType
  id?: string
  text?: string
  level?: number
  list?: { ordered?: boolean; items: string[] }
  table?: { headers?: string[]; rows: string[][] }
  language?: string
  link?: RichLink
  media?: RichMediaRef
  media_refs?: RichMediaRef[]
  card?: RichCard
  cards?: RichCard[]
  fallback_text?: string
}

export function hasRichResponse(doc: RichResponseV1 | null | undefined): boolean {
  return !!doc && Array.isArray(doc.blocks) && doc.blocks.length > 0
}

export function resolveAssetByOrdinal(
  assets: AIChatOutputAsset[] | undefined,
  ordinal: number,
): AIChatOutputAsset | undefined {
  return (assets || []).find((a) => a.ordinal === ordinal)
}

/** Primary “AI 生图” gallery semantics. Legacy unknown counts as generated until PC3 tags roles. */
export function isGeneratedAsset(asset: AIChatOutputAsset | undefined): boolean {
  const role = asset?.asset_role || 'unknown'
  return role === 'generated' || role === 'unknown'
}
